import { type MailboxInfo } from 'owa-client-types';
//import { lazyGetM365Acquisition } from 'owa-m365-acquisitions/lib/lazyFunction';
import { readM365AcquisitionsFromCache } from 'owa-m365-acquisitions/lib/readM365AcquisitionsFromCache';
import { isBizchatSidepaneEnabled } from 'owa-bizchat-shared/lib/utils/isBizchatSidepaneEnabled';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

function getCollaborationProtectionAgentTitleId(): string {
    return isGlobalFeatureEnabled('tri-scanSafetyWithCopilot-dev', true)
        ? 'T_e1ff59fc-513d-2f28-62f6-ef2376afbf64'
        : 'T_168cd541-9ef2-ded7-c953-b5efbffcaa7c';
}

/**
 * Determines if the scan safety feature with Copilot should be shown for the given mailbox.
 * Reads the agent acquisition from cache only to avoid flickering caused by async acquisition fetches.
 * @param mailboxInfo
 * @returns True if the feature should be shown, false otherwise.
 */
export function shouldShowScanSafetyWithCopilot(mailboxInfo: MailboxInfo): boolean {
    if (
        !isGlobalFeatureEnabled('tri-scanSafetyWithCopilot') ||
        !isBizchatSidepaneEnabled(mailboxInfo)
    ) {
        return false;
    }

    const acquisitions = readM365AcquisitionsFromCache(undefined, mailboxInfo);
    const acquisition = acquisitions.find(
        a => a.titleId.toLowerCase() === getCollaborationProtectionAgentTitleId().toLowerCase()
    );
    return acquisition?.acquisitionState === 'Acquired';
}
